import {
  ConfigObjectType,
  i18nContainer,
  loginContainer,
  utils,
} from '@wallaby-ui/core';
import {debounce} from 'lodash';
import * as React from 'react';
import {useEffect, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {connect, ConnectedProps} from 'react-redux';
import {exportData} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {I18N as LIST_CONTAINER_I18N} from 'src/js/containers/list/components/ListWrapperContainer';
import {RootState} from 'src/js/store';

import {ReportsBox} from './ReportsBox';
import {loadStateFromParams} from '../reports_thunks';

interface OwnProps {
  reportsStateId: string;
  config: ConfigObjectType;
  filterAndSearchStateId: string;
  reportId: string;
  serviceUrls: Record<string, any>;
  isLoading: boolean;
  isExportingCounter?: number;
  data: Record<string, any>;
  disableExport: boolean;
}

const mapState = (state: RootState, props: OwnProps) => ({
  currentLocale: state[i18nContainer.I18N_REDUCER_STATE_ID].currentLocale,
  locationState: state[props.reportsStateId].locationState,
  reportsConfig: state[props.reportsStateId].reportsConfig,
});

const mapDispatch = {
  loadStateFromParams,
  exportData,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const ReportsContainerComponent: React.FC<Props> = (props) => {
  const {
    filterAndSearchStateId,
    reportId,
    reportsStateId,
    serviceUrls,
    exportData,
    isExportingCounter = 0,
    isLoading = false,
    currentLocale,
    locationState,
    config,
    data,
    disableExport,
  } = props;
  const intl = useIntl();

  const debouncedExportData = useMemo(
    () => debounce(exportData, 500).bind(this),
    [exportData]
  );

  useEffect(() => {
    loadStateFromParams(reportsStateId, filterAndSearchStateId, reportId);
  }, [filterAndSearchStateId, locationState, reportId, reportsStateId]);

  useEffect(() => {
    if (locationState.reload) {
      loadStateFromParams(reportsStateId, filterAndSearchStateId, reportId);
    }
  }, [filterAndSearchStateId, locationState, reportId, reportsStateId]);

  const handleExport = () => {
    // export data
    debouncedExportData(
      filterAndSearchStateId,
      serviceUrls.searchService,
      {lang: currentLocale},
      config.service.url.filesExportMethod,
      utils.TranslateUtils.translate(LIST_CONTAINER_I18N.EMPTY_EXPORT, intl)
    );
  };

  return (
    <ReportsBox
      filterAndSearchStateId={filterAndSearchStateId}
      reportsStateId={reportsStateId}
      isExportingCounter={isExportingCounter}
      isLoading={isLoading}
      reportId={reportId}
      handleExport={handleExport}
      serviceUrls={serviceUrls}
      data={data}
      disableExport={disableExport}
    />
  );
};

ReportsContainerComponent.displayName = 'ReportsContainer';

export const ReportsContainer = connector(ReportsContainerComponent);
